import { Component, Input, OnDestroy } from '@angular/core';
import { combineLatest, Subject, Subscription, takeUntil } from 'rxjs';
import { GasprecioService } from '../../../gasprecio/services/gasprecio.service';
import { SharedService } from '../../../gasprecio/services/shared.service';
import { Router, Event as NavigationEvent, NavigationEnd } from '@angular/router';
import Highcharts from 'highcharts';
import { GroupIds } from 'src/app/modules/gasprecio/enums/groups-ids.enum';
import moment from 'moment';

@Component({
  selector: 'app-chart-sales-shift',
  templateUrl: './chart-sales-shift.component.html',
  styleUrls: ['./chart-sales-shift.component.scss']
})
export class ChartSalesShiftComponent implements OnDestroy {

  @Input() variable = 'transactions';
  @Input() type = 'Autos';
  @Input() station: any = false;

  stationSelected$!: Subscription;
  stationSelected!: string;

  chartOptions: Highcharts.Options;
  data = [];
  date = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
  event$!: Subscription;
  Highcharts = Highcharts;
  idGroup: GroupIds | string = GroupIds.Pa;
  loading = false;
  private destroy$ = new Subject<void>();
  productType = 'regular';
  reqst = 0;
  rol;
  route;
  stationId: any;
  period;
  zone;
  changeZone = false;

  constructor(
    private gasprecioService: GasprecioService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this.rol = localStorage.getItem('rol');
    this.idGroup = (this.rol === 'Dios') ? localStorage.getItem('group') || GroupIds.Pa : localStorage.getItem('group');
    this.stationId = localStorage.getItem('idStation');
    this.event$ = this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        this.route = /[^/]*$/.exec(event.url)[0];
      }
    });

    this.stationSelected$ = this.sharedService.sharedStation.subscribe(stationSelected => {
      if (!this.station && stationSelected !== '') {
        this.stationSelected = stationSelected;
      }
    });

    combineLatest([
      this.sharedService.sharedGroup,
      this.sharedService.sharedZone,
      this.sharedService.sharedStationSelected,
      this.sharedService.sharedSelectedMonth,
      this.sharedService.sharedProductTypeTotal,
    ]).pipe(takeUntil(this.destroy$)).subscribe(([idGroup, zone, stationId, period, productType]) => {
      if (idGroup !== this.idGroup) {
        this.idGroup = idGroup;
      }

      if (this.zone !== zone) {
        if (this.zone !== undefined) {
          this.changeZone = true;
        }
        this.zone = zone;
      }

      if (this.stationId !== stationId) {
        this.stationId = stationId;
      }

      if (period !== this.date) {
        this.date = period;
      }

      if (this.productType !== productType) {
        this.productType = productType;
      }

      if (!this.loading) {
        this.getHeatMapTotalShift();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.stationSelected$.unsubscribe();
  }

  getHeatMapTotalShift() {
    this.loading = true;
    this.reqst = 0;
    this.data = [];


    this.stationSelected$ = this.sharedService.sharedStation.subscribe(stationSelected => {
      if (!this.station && stationSelected !== '') {
        this.stationSelected = stationSelected;
      }
    });

    setTimeout(() => {

      const stationCondition = this.station || (this.stationSelected$ && this.stationSelected !== 'zone');
      let url: any;

      if (stationCondition) {
        url = this.gasprecioService.getHeatMapTotalShift(this.idGroup, this.stationId, this.variable, this.productType, this.date, false, true, this.stationSelected);
      } else if (this.zone === '' || !this.zone) {
        url = this.gasprecioService.getHeatMapTotalShift(this.idGroup, this.stationId, this.variable, this.productType, this.date, false);
      } else {
        url = this.gasprecioService.getHeatMapTotalShift(this.idGroup, this.zone, this.variable, this.productType, this.date, true);
      }


      url.subscribe({
        next: (data: any) => {
          const shifts = ["shift1", "shift2", "shift3"];
          data.sort((a, b) => {
            const indexA = shifts.indexOf(a.shift) === -1 ? Number.MAX_VALUE : shifts.indexOf(a.shift);
            const indexB = shifts.indexOf(b.shift) === -1 ? Number.MAX_VALUE : shifts.indexOf(b.shift);
            return indexA - indexB;
          });
          data.map((x: any, index) => {
            this.data.push({ name: `Turno ${index + 1} -  ${this.gasprecioService.numberWithCommas(x['value']?.toFixed(0))}`, y: +x['pct']?.toFixed(1), color: x['shift'] === 'shift1' ? '#4B5E89' : x['shift'] === 'shift2' ? '#4B8DDC' : x['shift'] === 'shift3' ? '#F3C911' : '' });
          });
          this.setData();
        }, complete: () => {
          this.reqst = 1;
        }, error: () => {
          this.loading = false;
          this.reqst = 2;
        }
      });
    }, 400);
  }

  setData() {
    this.chartOptions = {
      credits: {
        enabled: false
      },
      chart: {
        type: 'pie',
        plotShadow: false
      },
      title: {
        text: `Distribución de ${this.type} por Turno`,
        style: {
          fontSize: '0'
        }
      },
      exporting: {
        filename: `Distribución de ${this.type} por Turno`,
        sourceWidth: 1200,
        sourceHeight: 800,
      },
      navigation: {
        buttonOptions: {
          align: 'right',
          y: -10
        }
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        itemDistance: 10,
        y: 1,
        padding: 1,
        itemMarginTop: 1,
        itemMarginBottom: 1,
        itemHoverStyle: {
          color: '#00E07B',
        }
      },
      xAxis: {
        categories: [],
        gridLineWidth: 1,
        gridLineDashStyle: 'LongDash',
        title: {
          text: 'Fecha',
          style: {
            fontSize: '0'
          }
        },
        labels: {
          style: {
            fontSize: '11px',
          },
          y: 14
        }
      },
      yAxis: [
        {
          title: {
            text: 'Autos',
            style: {
              fontSize: '0'
            }
          },
          labels: {
            format: this.type === 'Autos' ? '{value:,.0f}' : '{value:,.0f} lts',
            style: {
              fontSize: '11px'
            }
          },
          tickAmount: 10,
          gridLineDashStyle: 'LongDash'
        }
      ],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            distance: 10
          },
          showInLegend: true
        }
      },
      series: [{
        type: 'pie',
        innerSize: '60%', // Hace que sea un gráfico de dona
        name: 'Turnos',
        data: this.data
      }]
    };

    setTimeout(() => {
      this.loading = false;
    }, 100);
  }
}